<template>
  <span class="flex flex-col justify-center items-center">
    <!-- Logo -->
    <img
      class="w-12 h-12 animate-bounce drop-shadow-lg"
      src="@/assets/givvy.png"
      alt="Givvy Logo"
    />
    <!-- Text -->
    <p class="mt-2 text-gray-600 text-sm font-medium">Loading...</p>
  </span>
</template>

<script>
export default {
  name: 'GivarooSpinner',
}
</script>

<style></style>
